import styled from 'styled-components';

import { device } from '@/ui/styles/breakpoints';

type IsVisibleProps = {
  $isVisible: boolean;
};

type ManualSidebarProps = {
  $isVisible: boolean;
  $sidebarIsComments?: boolean;
};

export const ManualSidebar = styled.div<ManualSidebarProps>`
  background: ${props => props.theme.palette.gray.light};
  padding: 20px;
  width: 100%;

  @media ${device.min.md} {
    align-self: stretch;
    display: ${props => (props.$isVisible ? 'block' : 'none')};
    flex-shrink: 0;
    margin-left: 20px;
    overflow: auto;
    padding-top: 0;
    position: relative;
    width: 360px;
  }

  @media ${device.max.md} {
    border-top: 1px ${props => props.theme.palette.gray.main} solid;
    height: calc(100dvh - 98px);
    overflow-y: auto;

    ${props =>
    props.$sidebarIsComments &&
    `
      height: calc(100% - 39px);
      left: 0;
      overflow: hidden;
      position: fixed;
      top: 0;
      z-index: 150000;
      width: 100%;
    `}
  }

  h3 {
    background: ${props => props.theme.palette.gray.light};
    font-size: 14px;
    margin: -20px -20px 0;
    left: 0;
    padding: 19px 52px 19px 20px;
    /* position: sticky; */
    /* top: 0; */
  }

  > div {
    width: 100%;

    @media ${device.min.md} {
      left: 0;
      padding: 20px;
      position: absolute;
      top: 0;
    }
  }
`;

export const ManualSidebarClose = styled.button`
  background: transparent;
  border: 0;
  color: #797979;
  display: block;
  height: 22px;
  position: sticky;
  left: 100%;
  margin-top: -2px;
  top: 19px;
  width: 22px;
  z-index: 2;

  @media ${device.max.md} {
    display: none;
  }

  svg {
    cursor: pointer;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }
`;

export const ManualContents = styled.div<IsVisibleProps>`
  display: ${props => (props.$isVisible ? 'block' : 'none')};
`;

export const ManualComments = styled.div<IsVisibleProps>`
  display: ${props => (props.$isVisible ? 'block' : 'none')};
`;

export const ManualCommentsHeadline = styled.div`
  display: flex;
  justify-content: space-between;
  position: relative;

  button {
    display: none;
  }

  @media ${device.max.md} {
    button {
      display: block;
    }
  }
`;

export const ManualCommentsWrapper = styled.div`
  @media ${device.max.md} {
    height: 100%;
    margin-left: -20px;
    margin-right: -20px;
    overflow-y: auto;
    padding-left: 20px;
    padding-right: 20px;
  }
`;

export const ManualCommentsHide = styled.button`
  background: transparent;
  border: 0;
  color: ${({ theme }) => theme.custom.colors.gray500};
  display: block;
  height: 22px;
  margin-top: -3px;
  padding: 0;
  width: 22px;
  z-index: 2;

  svg {
    cursor: pointer;
    height: 22px;
    width: 22px;
  }
`;
